<footer class="text-center" *ngIf="isNoveNoveAbastece">
  <button type="button" class="btn cupom-button" (click)="onBenefitButtonClick()">
    <ng-container *ngIf="isDesktop">Ativar benefício</ng-container>
    <ng-container *ngIf="!isDesktop">{{ "DETAIL.ESTABLISHMENT.GENERATE_COUPON_BUTTON" | translate }}</ng-container>
  </button>
</footer>

<ng-core-modal #modalPhone [config]="modalConfig">
  <form class="modal-99checkout" (ngSubmit)="activateBenefit()">
    <h3 class="modal-99checkout-title">
      {{ hasSavedPhone ? "Confirme seu celular" : "Digite seu celular" }}
    </h3>

    <input
      type="tel"
      name="phone"
      class="form-control modal-99checkout-input"
      placeholder="(11) 91234-5678"
      autocomplete="tel"
      [textMask]="{ mask: telephoneMask, guide: false }"
      [(ngModel)]="phone"
      [disabled]="isLoading"
    />

    <button
      type="submit"
      class="btn btn-activate-benefit modal-99checkout-button"
      [disabled]="!isPhoneComplete || isLoading"
    >
      <span *ngIf="!isLoading">Ativar benefício</span>
      <span *ngIf="isLoading" class="modal-99checkout-spinner"></span>
    </button>
  </form>
</ng-core-modal>

<!-- Desktop: ativação exclusiva pelo app via QR code -->
<ng-core-modal #modalApp [config]="modalAppConfig">
  <div class="modal-99abastece">
    <div class="modal-99abastece-copy">
      <h3>Ops! Ative o 99Abastece pelo app!</h3>
      <p>
        Para oferecer uma experiência ainda melhor e garantir o melhor uso do benefício, a ativação do 99Abastece está disponível exclusivamente pelo nosso aplicativo.
      </p>
      <p>
        Abra a câmera do celular, escaneie o QR Code e acesse o app.
      </p>
      <p>
        Para mais informações acesse nossa
        <a
          href="https://ajuda.allya.com.br/pt-BR/"
          target="_blank"
          rel="noopener"
          class="modal-99abastece-link"
        >Central de Ajuda!</a>
      </p>
    </div>
    <div class="modal-99abastece-media">
      <img src="assets/shared/img/99-qrcode.png" alt="QR Code para baixar o app Allya" />
      <div class="modal-99abastece-stores">
        <a
          href="https://play.google.com/store/apps/details?id=com.allyaapp&hl=pt_BR&gl=US&pli=1"
          target="_blank"
          rel="noopener"
        >
          <img src="assets/shared/img/google-play.png" alt="Disponível no Google Play" />
        </a>
        <a
          href="https://apps.apple.com/br/app/allya/id1398933563"
          target="_blank"
          rel="noopener"
        >
          <img src="assets/shared/img/apple-app.png" alt="Disponível na App Store" />
        </a>
      </div>
    </div>
  </div>
</ng-core-modal>
